import { render } from "./AccountGeneral.vue?vue&type=template&id=048bcf81&ts=true"
import script from "./AccountGeneral.vue?vue&type=script&lang=ts"
export * from "./AccountGeneral.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__